// import wikiImg from '../../image/wikipediaExternalPage.png'
import { iRepo } from './interfaces'

export default class Code { // TODO change to ObjRepo
  repos: Array<iRepo> // same as object[]?
  gitUrlFront: string

  constructor () {
    this.repos = []
    this.gitUrlFront = 'https://github.com/gregsandell/'
  }

  loadData () {
    this.addRepo('movie-infinite-scroll', 'Movie Infinite Scroll',
      'React + axios frontend app that retrieves movie data from service at omdbapi.com and displays results ten at a time with infinite scroll. (<a href=\'https://replit.com/@GregSandell/Movie-Infinite-Scroll?v=1\' target=\'_BLANK\'>Code Sandbox</a>)'
    )
    this.addRepo('popular-tweets', 'Popular Tweets',
      'React + Express frontend app that connects to the Twitter API to display the most popular tweets, and allowing filtering by hashtag.'
    )
    // https://github.com/gregsandell/popular_tweets
    this.addRepo('tic-tac-toe', 'Tic Tac Toe',
      'A plain-JavaScript-coded game of Tic Tac Toe, played from the browser developer console or a REPL. (<a href=\'https://replit.com/@GregSandell/Tic-Tac-Toe?v=1\' target=\'_BLANK\'>Code Sandbox</a>)'
    )
    this.addRepo('CoffeeShop', 'Coffee Shop',
      'A command-line, menu-driven Java app that simulates the sales and inventory of a coffeeshop.'
    )
    this.addRepo('data-grid', 'Data Grid Rotator',
      'This is a JavaScript jQuery object that supports flipping x- and y-axes of data, and supports rotating data over a collection of charts. (<a href=\'http://gregsandell.com/misc/grid-rotator\' target=\'_BLANK\'>Demo here</a>)'
    )
  }

  // Discarded code repo listings
  //         this.addRepo("estimates", "Angular Transactional Form Sample",
  //             "This is an example of web form written in Angular, demonstrating usage of Templates, Controllers, Services, Routes, Directives, LESS, HTTP service mocking with API Blueprint, Internationalization, and testing with Mocha/Sinon/Chai."
  //         );
  //         this.addRepo("replaceWordsInPage", "Replace Words in Page",
  //             "This is a jQuery coding sample I wrote on request.  It demonstrates Screen-scraping of Wikipedia pages, Word-counting, Sorting, the Module pattern, Promises, Replacing text in an HTML page, rules definitions through predicates, and CSS selectors."
  //         );
  //         this.addRepo("right-left-select", "jQuery plugin",
  //             "This is a jQuery plugin I wrote for a UI element that moves text items from one container to another."
  //         );
  //         this.addRepo("analyze-characters", "Perl code sample",
  //             "At iCrossing we frequently received XML file feeds from clients which contained characters of mixed formats, instead of pure ASCII.  Mixed in with plain ASCII we might find WinLatin-1, ISO-8859-1, extended ASCII, or UTF-8.  This script analyzes every character to give a tally of how many of each character set type are present."
  //         );

  addRepo (repoName:string, title:string, desc:string):void {
    this.repos.push(new Repo(repoName, title, desc))
  }
}

class Repo {
  repoName:string
  title:string
  desc:string
  constructor (repoName:string, title:string, desc:string) {
    this.repoName = repoName
    this.title = title
    this.desc = desc
  }
}
